module.exports = __webpack_public_path__ + "img/result-detail-output-inleft02.841dcd13.svg";